"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostgresQueryTypeIterable = void 0;
exports.PostgresQueryTypeIterable = [
    'assetVerification',
    'principalBalanceDailyAverage',
    'principalBalancePointInTime',
    'tAccountsSum',
    'orgProvidedInput',
];
//# sourceMappingURL=Query.js.map